/** Webapp tab routes (TanStack Router paths). */
export const WebappRoutes = {
  ADVISORS: "/webapp",
  READINGS: "/webapp/readings",
  TODAY: "/webapp/today",
  COMPATIBILITY: "/webapp/compatibility",
  PALMISTRY: "/webapp/palmistry",
  SOULMATE: "/webapp/soulmate",
  AURA_SCAN: "/webapp/aura-scan",
  ADVISOR_INNER: "/webapp/advisors/inner",
  REPORT_VIEW: "/webapp/reports/view",
} as const

export type WebappRoute = (typeof WebappRoutes)[keyof typeof WebappRoutes]
